import { getApi, postApi, putApi } from 'utils/Api';
import {
  CreateOfficeLocationRequest,
  GetDispensaryResponse,
  GetDistrictResponse,
  OfficeLocationListResponse,
  OfficeLocationResponse,
  UpdateOfficeLocationRequest,
} from './types/officeLocationTypes';

const officeLocationApi = {
  fetchDistricts: ({ state }: { state: string }) => {
    return getApi<GetDistrictResponse>({
      url: `/dispensary_districts_for_state?state=${state}`,
      responseSchema: {},
    });
  },

  fetchDispensaryForDistrict: ({ state, district }: { state: string; district: string }) => {
    return getApi<GetDispensaryResponse>({
      url: `/dispensary_for_district?state=${state}&district=${district}`,
      responseSchema: {},
    });
  },

  fetchOfficeLocations: ({
    page,
    limit,
    isPrimary,
  }: {
    page: number;
    limit: number;
    isPrimary?: boolean;
  }) => {
    let url = `/organization/office-locations?page=${page}&limit=${limit}`;
    if (isPrimary !== undefined) {
      url += `&is_primary=${isPrimary}`;
    }
    return getApi<OfficeLocationListResponse>({
      url,
      responseSchema: {},
    });
  },

  createOfficeLocation: ({ officeLocations }: { officeLocations: CreateOfficeLocationRequest }) => {
    return postApi<{ success: boolean }, CreateOfficeLocationRequest>({
      url: `/organization/office-locations`,
      requestData: officeLocations,
      responseSchema: {},
    });
  },

  updateOfficeLocation: ({ data, officeId }: UpdateOfficeLocationRequest) => {
    return putApi<{ success: boolean }, UpdateOfficeLocationRequest['data']>({
      url: `/organization/office-locations/${officeId}`,
      requestData: data,
      responseSchema: {},
    });
  },

  getOfficeLocationById: ({ officeLocationId }: { officeLocationId: number }) => {
    return getApi<{ data: OfficeLocationResponse }>({
      url: `/organization/office-locations/${officeLocationId}`,
      responseSchema: {},
    });
  },
};

export default officeLocationApi;
